const convertTransferType = (value) => (value > 0 ? "accountant.recharge" : "accountant.transfer");

export function parseWalletType(type) {
  switch (type) {
    case "SELLER_PERSONAL":
    case "SELLER_COMPANY":
      return "accountant.walletType.virtual";

    case "WAREHOUSE_ACCOUNTANT":
      return "accountant.walletType.accountant";

    case "BANK_ACCOUNT":
      return "accountant.walletType.bank";

    case "SELLER_DEBT":
      return "accountant.walletType.debt";

    default:
      return "";
  }
}

function parseBankTransferType(type) {
  switch (type) {
    case "COMPANY_TO_COMPANY":
      return "accountant.transactionType.companyToCompany";

    case "COMPANY_TO_PERSONAL":
      return "accountant.transactionType.companyToPersonal";

    case "PERSONAL_TO_PERSONAL":
      return "accountant.transactionType.personalToPersonal";

    case "PERSONAL_TO_COMPANY":
      return "accountant.transactionType.personalToCompany";

    default:
      return "";
  }
}

export const convertDataSeller = (data) =>
  data?.map((record) => ({
    createdAt: record.createdAt,
    sellerId: record.wallet.seller?.id,
    sellerCode: record.wallet.seller?.code,
    sellerName: record.wallet.seller?.fullName,
    billId: record.id,
    sourceWallet: record.walletTransfer?.sourceWallet?.type,
    walletType: parseWalletType(record.wallet.type),
    amount: record.amount,
    createdBy: record.walletTransfer?.createdBy?.email,
    orderID: record.walletTransfer?.orderID,
    orderCode: record.walletTransfer?.order?.formattedNumber,
    description: record.walletTransfer?.description,
    fileURLs: record.walletTransfer?.fileURLs,
    bankTransferType: parseBankTransferType(record.transferType),
  }));

function parseTargetWallet(transaction) {
  if (transaction.amount < 0) {
    return transaction?.walletTransfer?.targetWallet;
  }
  return transaction?.walletTransfer?.sourceWallet;
}

export const convertDataWarehouseAccountantTransaction = (data) =>
  data?.map((record) => ({
    createdAt: record?.createdAt, // Thơi gian
    idAgent: record?.walletTransfer?.targetWallet?.seller
      ? record?.walletTransfer?.targetWallet?.seller?.id
      : record?.walletTransfer?.targetWallet?.user?.id, //Mã tài khoản
    nameAccountantWarehouse: record?.walletTransfer?.createdBy?.fullname, // Tên kế toán kho
    id: record?.id, // Mã giao dịch
    sourceType: record?.sourceType, // Nguồn tiền
    targetWallet: parseTargetWallet(record), //Ví giao dịch
    amount: record.amount, //Số tiền
    executor: record.walletTransfer?.createdBy?.email, // Người thực hiện
    description: record.walletTransfer?.description, // Ghi chú
    fileURLs: record.walletTransfer?.fileURLs || [], // File
    isSeller: record.walletTransfer?.targetWallet?.seller ? true : false, // Xem có phải đại lý hay không
    sellerCode: record.walletTransfer?.targetWallet?.seller?.code, // mã đại lý
    transferType: convertTransferType(record?.amount), //Loại giao dịch,
    accountantName: record?.walletTransfer?.targetWallet?.seller
      ? record?.walletTransfer?.targetWallet?.seller?.shortName
      : record?.walletTransfer?.targetWallet?.user?.fullname, //Tên kế toán kho
    createdByID: record.walletTransfer?.createdByID,
  }));
